import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'default' | 'white' | 'dark';
}
export function Section({
  children,
  className = '',
  id,
  background = 'default'
}: SectionProps) {
  const bgStyles = {
    default: 'bg-[#F8F8F6]',
    white: 'bg-white',
    dark: 'bg-[#00316B] text-white'
  };
  return <section id={id} className={`py-20 md:py-32 px-4 ${bgStyles[background]} ${className}`} data-id="element-238">
      <div className="max-w-7xl mx-auto w-full" data-id="element-239">{children}</div>
    </section>;
}